import api from 'shared/api';
import {ICartGet, ICartGetResp} from 'shared/interfaces/requests/cart';

export async function getCart(cartInfo: ICartGet) {
	return api.post<ICartGet, ICartGetResp>('getCart', cartInfo);
}
